import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-wrap items-center gap-2",
  "data-testid": "document-queue-filter-bar"
}
const _hoisted_2 = { class: "relative flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Buscar médico ou CRM", -1)
const _hoisted_4 = ["value"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import SelectFilter from '@/components/Filters/SelectFilter.vue'
import { DOCUMENT_STATUS_LABEL } from '@/components/ProfessionalDocuments/labels'
import { EMPTY_REVIEW_FILTERS } from '@/pinia-store/useDocumentReviewStore'
import type { ReviewQueueFilters } from '@/pinia-store/useDocumentReviewStore'
import { useProfessionalDocumentCatalogStore } from '@/pinia-store/useProfessionalDocumentCatalogStore'
import { ProfessionalDocumentStatus } from '@/types/professional-documents.types'

import { REVIEW_TAG_OPTIONS } from '../constants'

type SelectKey = 'tag' | 'status' | 'typeKey'

const SEARCH_DEBOUNCE_MS = 300


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentQueueFilterBar',
  props: {
    filters: {}
  },
  emits: ["change"],
  setup(__props: any, { emit }) {

const props = __props;




const catalog = useProfessionalDocumentCatalogStore()

const TAG_OPTIONS = REVIEW_TAG_OPTIONS.map(({ title, value }) => ({ label: title, value }))
const STATUS_OPTIONS = Object.values(ProfessionalDocumentStatus).map((value) => ({
  label: DOCUMENT_STATUS_LABEL[value],
  value
}))

const selects = computed(() => [
  { key: 'tag' as const, testId: 'tag', label: 'Tags', options: TAG_OPTIONS, searchable: false },
  {
    key: 'status' as const,
    testId: 'status',
    label: 'Status do documento',
    options: STATUS_OPTIONS,
    searchable: false
  },
  {
    key: 'typeKey' as const,
    testId: 'type',
    label: 'Tipo de documento',
    options: catalog.types.map((type) => ({ label: type.name, value: type.key })),
    searchable: true
  }
])

/* ---------------------------------------------------------------- busca */

const searchText = ref(props.filters.search)
let searchDebounce: ReturnType<typeof setTimeout> | undefined
const cancelSearchDebounce = () => clearTimeout(searchDebounce)

const hasFilters = computed(() =>
  Boolean(
    searchText.value.trim() || props.filters.tag || props.filters.status || props.filters.typeKey
  )
)

function onSearchInput(value: string) {
  searchText.value = value
  cancelSearchDebounce()
  searchDebounce = setTimeout(
    () => emit('change', { ...props.filters, search: value }),
    SEARCH_DEBOUNCE_MS
  )
}

// Mudança de fora (ex.: limpar pela tela): o campo acompanha e a busca pendente cai.
watch(
  () => props.filters.search,
  (search) => {
    if (search === searchText.value) return
    cancelSearchDebounce()
    searchText.value = search
  }
)

/* ---------------------------------------------------------------- selects */

const openFilter = ref<SelectKey | null>(null)
const toggleOpen = (key: SelectKey) => {
  openFilter.value = openFilter.value === key ? null : key
}

/** Selecionar a opção já ativa desmarca o filtro. */
function onSelect(key: SelectKey, value: string) {
  cancelSearchDebounce()
  openFilter.value = null
  const next = props.filters[key] === value ? null : value
  // O valor vem das opções desta chave (tag/status/tipo do catálogo).
  emit('change', { ...props.filters, search: searchText.value, [key]: next } as ReviewQueueFilters)
}

function clear() {
  cancelSearchDebounce()
  searchText.value = ''
  openFilter.value = null
  emit('change', { ...EMPTY_REVIEW_FILTERS })
}

const closeOnOutsideClick = () => {
  openFilter.value = null
}
onMounted(() => document.addEventListener('click', closeOnOutsideClick))
onBeforeUnmount(() => {
  document.removeEventListener('click', closeOnOutsideClick)
  cancelSearchDebounce()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        type: "search",
        value: searchText.value,
        maxlength: "100",
        placeholder: "Buscar médico ou CRM",
        class: "h-8 w-64 rounded-md border border-lightGray30 px-3 text-sm",
        "data-testid": "document-queue-search-input",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (onSearchInput(($event.target as HTMLInputElement).value)))
      }, null, 40, _hoisted_4)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selects.value, (select) => {
      return (_openBlock(), _createBlock(SelectFilter, {
        key: select.key,
        label: select.label,
        options: select.options,
        searchable: select.searchable,
        "is-open": openFilter.value === select.key,
        "selected-value": _ctx.filters[select.key],
        "dropdown-width": "w-64",
        "data-testid": `document-queue-${select.testId}-filter`,
        onToggle: ($event: any) => (toggleOpen(select.key)),
        onSelect: (value) => onSelect(select.key, value),
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, null, 8, ["label", "options", "searchable", "is-open", "selected-value", "data-testid", "onToggle", "onSelect"]))
    }), 128)),
    (hasFilters.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "text-sm font-semibold text-primary30 underline",
          "data-testid": "document-queue-clear-filters",
          onClick: clear
        }, " Limpar filtros "))
      : _createCommentVNode("", true)
  ]))
}
}

})